module.exports = __webpack_public_path__ + "static/media/x-icon.8bf31c9b.svg";